//nome = codigo no BD
export const enum EStatusDoItem {
  'PendenteDeEnvioParaAprovacao' = 1,
  'AprovacaoClausulaNivel1' = 2,
  'AprovacaoClausulaNivel2' = 3,
  'Aprovado' = 4,
  'Reprovado' = 5,
  'Obsoleto' = 6,
}
